import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ToolingTypeService extends Service {
	constructor(injector: Injector) {
		super("ToolingType", injector);
	}

	// API
	active() {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Active`);
	}
}